<div class="modal-column" *ngIf="auth.isAuthenticated() && auth.userInfo">
  <div class="fitter">
    <div class="signup-left-content">
      <h3 class="join-edg-heading">Verify your identity</h3>
      <div class="signup-image"></div>
      <div class="signup-value-wrap">
        <div class="_18-plus-icon">
          <div>18+</div>
        </div>
      </div>
    </div>
    <div class="form-wrap">
      <form (ngSubmit)="submit()" [formGroup]="form" enctype="multipart/form-data" novalidate>

        <div class="input-wrap">
          <app-form-input formControlName="firstName" title="First name" data-id="signup3-firstName-input">
          </app-form-input>
          <app-form-input formControlName="lastName" title="Last name" data-id="signup3-lastName-input">
          </app-form-input>
        </div>

        <app-form-select [options]="countriesSelect" formControlName="nationality" title="Nationality"
                         placeholder="Choose your nationality" data-id="signup3-nationality-select"></app-form-select>
        <div class="fields-sideflex">
          <app-form-radio formControlName="docType" value="driving_licence" data-id="signup3-drivingLicense-radio">
            Driver's licence
          </app-form-radio>
          <app-form-radio formControlName="docType" value="national_identity_card" data-id="signup3-id-radio">
            ID Card
          </app-form-radio>
          <app-form-radio formControlName="docType" value="passport" data-id="signup3-passport-input">
            Passport
          </app-form-radio>
        </div>

        <app-file-uploader
          name="docFile"
          data-id="signup3-front-upload"
          (files)="setFiles($event)"
          [ngClass]="{'uploaded' : form.value.docFile}">Attach front side <i class="fal fa-plus"></i></app-file-uploader>

        <app-file-uploader
          name="docFile"
          data-id="signup3-back-upload"
          (files)="setFiles($event, true)"
          [ngClass]="{'uploaded' : form.value.docFileBack}">Attach back side <i class="fal fa-plus"></i></app-file-uploader>


        <div (click)="openSelfie()" class="selfie-uploader">
          <label class="attachment">
            <div>
              <div class="text-ellipsis" *ngIf="!form.value.docFileSelfie">
                Make a selfie of yourself  <i class="fal fa-camera"></i>
              </div>
              <div class="text-ellipsis" *ngIf="form.value.docFileSelfie">
                Selfie added  <i class="fal fa-check"></i>
              </div>
            </div>
          </label>
        </div>

        <app-form-button type="submit" class="primary full-width" [loading]="loading" data-id="signup3-verify-button">
          Verify identity
        </app-form-button>
      </form>
    </div>
    <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup" data-id="signup3-close-href">
      <i class="fal fa-times"></i>
    </a>
  </div>
    <br><br>
    <p class="fitt">
      For faster identification we require that documents uploaded would be in latin characters.
      <br>
      Documents must have your full name, number date of birth and date of expiration.
      <br>
      We accept only government identification cards, driver licenses and passports.
    </p>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/signup/3/signup-modal.template.html